import { TableContextProvider } from "./tableContext/TableContext";
import { TableProps } from "./tableTypes";
import TableInner from "./TableInner";

const Table = (props: TableProps) => {
    return (
        <TableContextProvider initialFilters={props.filters}>
            <TableInner {...props} initialFilters={props.filters} />
        </TableContextProvider>
    );
}

export default Table;